var _circle, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCookies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#ffc416",
    opacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f6ba5a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.36 9c1.839.007 3.659.369 5.362 1.064 1.382.538-3.108 2.176 1.727 6.37l1.132.867-.377 2.864c.326.165 2.021-2.025 2.594-1.952 1.58.29 1.8-2.183 2.486-.621A13.71 13.71 0 0 1 37.36 23c0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.36 10c-3.472 0-6.737 1.352-9.192 3.808S10.36 19.528 10.36 23s1.352 6.737 3.808 9.192S19.888 36 23.36 36s6.737-1.352 9.192-3.808S36.36 26.472 36.36 23c0-1.516-.266-3.077-.741-4.386-.366.32-.876.623-1.565.623a2.32 2.32 0 0 1-.154-.005c-.235.169-.658.578-.901.813-.727.704-1.166 1.129-1.753 1.129-.171 0-.341-.04-.492-.116l-.633-.32.394-2.995-.72-.554c-3.569-3.096-2.706-5.317-2.085-6.434-1.485-.514-2.883-.755-4.349-.755m0-1c1.794 0 3.509.337 5.362 1.064 1.382.538-3.108 2.176 1.727 6.37l1.132.867-.377 2.864c.321.162 1.966-1.954 2.565-1.954l.029.002c1.195.22 1.611-1.142 2.041-1.142.138 0 .278.141.445.522.643 1.447 1.075 3.377 1.075 5.408 0 7.732-6.268 14-14 14s-14-6.268-14-14 6.268-14 14-14z",
    fill: "rgba(155,102,53,0.23)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#3d0f0f"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 23,
    r: 2,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 20.5,
    r: 2.5,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 30,
    r: 2,
    opacity: 0.49
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 25.5,
    r: 1.5,
    opacity: 0.66
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 16,
    r: 1,
    opacity: 0.54
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookies);
export default __webpack_public_path__ + "static/media/cookies.152af7d47bee4d36d82e964ced695e11.svg";
export { ForwardRef as ReactComponent };